import { render } from "./StartScreenTools.vue?vue&type=template&id=51264e4a&scoped=true"
import script from "./StartScreenTools.vue?vue&type=script&lang=js"
export * from "./StartScreenTools.vue?vue&type=script&lang=js"

import "./StartScreenTools.vue?vue&type=style&index=0&id=51264e4a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51264e4a"]])

export default __exports__